import React from "react";
import ContactAddress from "./ContactAddress";

function ContactForm() {
  return (
    <section className="contact-area pt-110 pb-110">
      <div className="container">
        <div className="container-inner-wrap">
          <div className="row justify-content-center justify-content-lg-between">
            <div className="col-lg-6 col-md-8 order-2 order-lg-0">
              <div className="contact-title mb-20">
                <h5 className="sub-title">Escríbenos</h5>
                <h2 className="title">
                  Dinos tu duda o pregunta<span>.</span>
                </h2>
              </div>
              <div className="contact-wrap-content">
                <p>
                  ¡Nos encantaría saber de ti! Si tienes preguntas, sugerencias
                  o deseas más información sobre nuestros servicios, no dudes en
                  contactarnos. Tu opinión es muy valiosa para nosotros y
                  estamos aquí para ayudarte. Completa el formulario a
                  continuación o envíanos un correo electrónico, y te
                  responderemos a la brevedad. ¡Gracias por ser parte de nuestra
                  comunidad!
                </p>
                <form className="contact-form">
                  <div className="form-grp">
                    <label htmlFor="name">
                      Tú Nombre <span>*</span>
                    </label>
                    <input type="text" id="name" placeholder="Jon Deo..." />
                  </div>
                  <div className="form-grp">
                    <label htmlFor="email">
                      Tú Email <span>*</span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      placeholder="info.example@.com"
                    />
                  </div>
                  <div className="form-grp">
                    <label htmlFor="message">
                      Tú Mensaje <span>*</span>
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      placeholder="Quisiera saber cómo..."
                      defaultValue={""}
                    />
                  </div>
                  <button type="button" className="btn rounded-btn">
                    Enviar Mensaje
                  </button>
                </form>
              </div>
            </div>

            <ContactAddress />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
